import { call, select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { done } from '../readerTaskOrchestration.slice';
import { prepareCommonData } from './prepareCommonData';
import { detectIsViewerByUrl } from 'src/pages/Readings/ReadingTaskPage/hooks/useDetectIsViewerByUrl';
import { DICOMViewerSlice } from '@restore/DICOMViewer/DICOMViewer.slice';
import { dispatch } from '@dynamika-shared/utils/saga';
import { startReaderTask } from '@restore/readerTask/readerTask.slice';
import { TASK_STATUSES } from './constants';
import { ReaderTaskType } from '@dynamika-shared/types/reader';
import { mapUserRoleToViewerMode } from './viewerModeMapper';
import { selectAuthState } from '@restore/auth/auth.slice';
import { ClinicalTrialInventoryScoringFormType } from '@dynamika-shared/types/clinicalTrialInventory';

export function* startReaderTaskIfNeededSaga(task: ReaderTaskType) {
  if (!task) {
    return;
  }

  if (task.status === TASK_STATUSES.READING_PENDING || !task?.status) {
    yield dispatch(
      startReaderTask({
        clinicalTrialId: task.clinicalTrialId ?? '',
        parentTaskId: task.parentTaskId,
        taskId: task.id ?? '',
      })
    );
  }
}

export function* handleNormalTaskSaga(): SagaIterator {
  const {
    task,
    currentVisit,
    measurements,
    instruments,
    scoringForms,
    formConfig,
    labelGroups,
    clinicalTrialName,
  } = yield call(prepareCommonData);

  yield call(startReaderTaskIfNeededSaga, task);

  const authState = yield select(selectAuthState);
  const selectedRole = authState?.data?.selectedRole;

  const isViewer = detectIsViewerByUrl(
    task?.clinicalTrialId ?? '',
    task?.id ?? '',
    selectedRole
  );

  if (isViewer) {
    const viewerMode = mapUserRoleToViewerMode(selectedRole);

    yield dispatch(DICOMViewerSlice.actions.runViewer({
      role: selectedRole,
      mode: viewerMode,
    }));
  }

  yield dispatch(
    done({
      formConfig,
      childScoringForms: scoringForms as ClinicalTrialInventoryScoringFormType[],
      measurementsConfig: measurements,
      instrumentsConfig: instruments,
      clinicalTrialId: task?.clinicalTrialId ?? '',
      taskId: task?.id ?? '',
      task: task ?? {},
      readOnly: task?.status === 'COMPLETED',
      subTasks: [],
      clinicalTrialName,
      readingCode: task?.readingCode ?? '',
      currentVisit,
      labelGroups,
    })
  );
}
